"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableLayout = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const TableLayout = (param)=>{
    let { data, debug, modulePosition, className } = param;
    const { title, description } = data;
    const { columns, data: rows } = (0, _react.useMemo)(()=>(0, _utils2.mapDataToTable)(data), [
        data
    ]);
    const { getTestId } = (0, _testidGenerator.default)();
    if (rows.length === 0 || columns.length === 0) {
        return (0, _utils.getModulesContentError)({
            debug,
            modulePosition,
            layout: 'TableModule'
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.TABLE_LAYOUT_ROOT),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.HeaderContainer, {
                children: [
                    title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.HeaderText, {
                        variant: "h4",
                        component: "h2",
                        "data-testid": getTestId(_constants.TABLE_LAYOUT_TITLE),
                        children: title
                    }) : null,
                    description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.HeaderText, {
                        "data-testid": getTestId(_constants.TABLE_LAYOUT_DESCRIPTION),
                        maxWidth: 600,
                        children: description
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.Table, {
                columns: columns,
                data: rows
            })
        ]
    });
};
exports.TableLayout = TableLayout;
